import React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { createAlert } from "../../redux/reducers/Alerts";
import queryString from "query-string";
import { trackPurchaseGA4, trackSignupGA4 } from "../../utils/utils";

type Props = {};
export const QueryParamBanner: React.FC<Props> = ({ }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { error, success, value, currency, event } = queryString.parse(
    location.search
  );

  if (error) {
    dispatch(
      createAlert({
        type: "error",
        message: error,
        timeout: 0,
      })
    );
  } else if (success) {
    dispatch(
      createAlert({
        type: "success",
        message: success,
        timeout: 0,
      })
    );
  }

  if (event === "purchase" && currency && value) {
    // trackPurchaseGA4(value, currency);
    if (window && (window as any).lintrk) {
      (window as any).lintrk("track", { conversion_id: 10568572 });
    }
    if (window && (window as any).rdt) {
      (window as any).rdt("track", "Purchase", {
        value: parseFloat(value.toString()),
        currency: (currency as string).toUpperCase(),
        itemCount: 1
      });
    }
  }

  return null;
};
export default QueryParamBanner;
